<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosLbuRoadAreaConfig"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="deptIdList" label="路区代码">
              <RoadAreaSelect update="roadAreaCode" v-model:value="queryForm.roadAreaCode" allowClear/>
            </dc-form-item>
            <dc-form-item name="deptScopeId" label="查看人">
              <user-select v-model:value="queryForm.employeeNo" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'roadAreaCode'">
            {{ record.roadAreaCode.join(',') }}
          </template>
          <template v-if="column.dataIndex === 'employeeNo'">
            {{ `${record.userName}(${record.employeeNo})` }}
          </template>
          <template v-if="column.dataIndex === 'updateBy'">
            {{ `${record.updateByName}(${record.updateBy})` }}
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'lbu_road_area_config_edit_btn'"
                >编辑</a-button
              >
              <a-button type="link" @click="deleteRow(record)" v-permission="'lbu_road_area_config_delete_btn'"
                >删除</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'lbu_road_area_config_add_btn'">新增</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
  <script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { ref, computed } from 'vue'
import {
  roadAreaConfigList,
  deleteRoadAreaConfig
} from '@/api/yuntuSales/roadAreaConfig'
import { listByParamCodes } from '@/api/common'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { Modal as AModal } from 'ant-design-vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
export default { name: 'DcCosLbuRoadAreaConfig' }
</script>
  <script setup lang="ts">
const editModalRef = ref<{ toggle: (row?: any) => void }>()

const tableRef = ref()
const queryForm = ref({})
// 获取列表
const fetch = async (params: any, callBack: (res: any) => void) => {
  try {
    const res = await roadAreaConfigList({ ...params })
    callBack(res)
  } catch (error) {
    console.log('fetcherror: ', error)
  }
}

const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  { title: '路区代码', dataIndex: 'roadAreaCode' },
  { title: '查看人', dataIndex: 'employeeNo' },
  { title: '更新人', dataIndex: 'updateBy' },
  { title: '更新时间', dataIndex: 'updateTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: any) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: any) => {
  Modal.delete({
    name: row.deptName,
    onOk() {
      deleteRoadAreaConfig({id: row.id}).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
</script>

  <style scoped></style>
